module.exports = __webpack_public_path__ + "img/free-tip.e5ca730f.png";